const Otherprojects = () => {
  return (
    <div>
      <div className='my-5'>
        <h1 className='text-2xl font-medium mb-5'>Other Web Development Projects</h1>
        <p className='font-bold'> Task Description</p>
        <p>
        You are also free to create any additional web-based project outside the predefined tasks. The project can be a website, web application, or web system that demonstrates the participant’s understanding of web development concepts, creativity in design, and problem-solving skills
        </p>
      </div>

      <hr/>
    </div>
  )
}

export default Otherprojects